class Image_Resize {
	constructor() {
		this.selectors = {
			document: document,
			image: '.fr-view img'
		};
		this.init();
		this.events();
	};
	init() {
		this.getNodes();
	}

	getNodes() {
		var _this = this;
		this.nodes = {};
		$.each(this.selectors, function(key, selector) {
			_this.nodes[key] = $(selector);
		});
	}

	events() {		
		this.nodes.image.addClass('img-fluid');
    }
}
new Image_Resize();